// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__3H5mI","bgimg":"Hero_bgimg__B5e4+","head":"Hero_head__jn65u"};